<template>
  <div style="height: 100%">
    <div class="sidebar-head">{{leftTitle}}</div>
    <el-menu
      :default-active="currentActive"
      :default-openeds="defaultOpenedList"
      class="sidebar-menus">
      <div v-for="(item, index) in menus" :key="index">
        <sub-menu v-if="item.children" :menu="item"></sub-menu>
        <menu-item v-else :menu="item" :key="index"/>
      </div>
    </el-menu>
  </div>
</template>

<script>
  import subMenu from './subMenu'
  import menuItem from './menuItem'
  import {getCookie} from '@/utils/cookie'


  export default {
    name: 'menus',
    computed: {
      menus() {
        if (this.$store.getters.menus) {
          if(this.defaultOpenedList.length < 1) {
            for (let i = 0; i < this.$store.getters.menus.length; i++) {
              this.defaultOpenedList.push(this.$store.getters.menus[i].index);
            }
          }
          return this.$store.getters.menus
        } else {
          this.$store.dispatch('initMenus').then(() => {
            if(this.defaultOpenedList.length < 1) {
              for (let i = 0; i < this.$store.getters.menus.length; i++) {
                this.defaultOpenedList.push(this.$store.getters.menus[i].index);
              }
            }
            return this.$store.getters.menus
          });
        }
      },
      currentActive() {
        return this.$route.path
      }
    },
    components: {
      subMenu,
      menuItem
    },
    data() {
      return {
        defaultOpenedList: [],
        leftTitle:undefined,
      }
    },
    methods: {
      // 需要获取登录用户类型
    },
    mounted(){
      this.leftTitle=getCookie('leftTitle');
  }
  }
</script>

<style lang="scss">
  // style dependency
  @import "@/assets/styles/variables.scss";

  .sidebar-head {
    height: 50px;
    font-size: 0.16rem;
    text-align: center;
    line-height: 50px;
    background: #f13a3a;
    color: #fff;
    margin-bottom: 5px;
    margin-left:-1px;
    margin-right:-1px;
  }

  .sidebar-menus {
    height: calc(100% - 57px);
    overflow: auto;
    border: solid 1px #e6e6e6 !important;
    border-top: 0px;
    &::-webkit-scrollbar{
      width:0px;
    }

    //下拉菜单左侧小箭头
    .el-submenu__icon-arrow {
      font-size: 16px;
      display: none;
    }

    .icon-right {
      font-size: 16px !important;
      position: absolute;
      top: 50%;
      right: 20px;
      margin-top: -7px;
      transition: transform .3s, -webkit-transform .3s;
    }

    .el-submenu.is-opened .icon-right {
      transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      -webkit-transform: rotate(90deg);
    }

    // private super class
    .menu-item {
      height: $menuHeight;
      line-height: $menuHeight;
      color: $menuFontColor;
      border-left: 5px solid #fff;
    }

    .menu-item:hover {
      background: $menuHoverColor;
      border-left: 5px solid #ffffe5;
    }

    .menu-item-active {
      color: $menuActiveColor;
      background: $menuActiveBackground;
      border-left: 5px solid $menuBorderColor;
    }

    .sub-menu {
      height: $subMenuHeight;
      line-height: 40px;
      background: $subMenuBackground;
      color: $menuFontColor;
      border-left: 5px solid #fff;
    }

    .sub-menu:hover {
      // color: $subMenuHoverColor;
      background: $subMenuBackground;
      border-left: 5px solid #ffffe5;

      i {
        // color: $subMenuHoverColor;
      }
    }

    .sub-menu-active {
      color: $subMenuActiveColor;
      background: $subMenuActiveBackground;
      border-left: 5px solid $menuBorderColor;
    }

    .el-menu-item:hover {
      // color: #e4393c;
      background-color: #ffffe5 !important;
    }

    .el-menu-item:focus {
      color: #e4393c !important;
      background-color: #f8f8f8 !important;
      border-left: 5px solid $menuBorderColor;
    }

    .el-submenu .el-menu-item {
      padding-left: 48px !important;
    }


    // style override
    background: transparent;
    border-right: none;

    div > .el-menu-item {
      @extend .menu-item;

      &.is-active {
        @extend .menu-item-active;
      }
    }

    div .i-sub-menu > .el-submenu {
      > .el-submenu__title {
        @extend .menu-item;

        &:hover {
          @extend .sub-menu:hover;
          border-left: 5px solid #fff;
        }

        &.is-active {
          @extend .menu-item-active;
        }
      }

      &.is-opened {
        > .el-submenu__title,
        > .el-menu > .i-sub-menu > .el-menu-item {
          @extend .sub-menu;

          &.is-active {
            @extend .sub-menu-active;
          }
        }

        .el-submenu {
          > .el-submenu__title,
          > .el-submenu__title > i,
          > .el-menu > .el-menu-item {
            @extend .sub-menu;

            &.is-active {
              @extend .sub-menu-active;
            }
          }

          @extend .sub-menu;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MainLayout/components/Menus/index.vue